import { createI18n } from 'vue-i18n'
import { getCurrentLanguage } from '@eureka/language-tool'
import _ from 'lodash'

export function createI18nInstance(locale?: string) {
    locale = locale || getCurrentLanguage()
    return createI18n({
        legacy: false,
        locale,
        fallbackLocale: 'en',
        messages: {},
    })
}
export const i18n = createI18nInstance()

export async function loadI18n() {
    const lang = getCurrentLanguage()
    let results;
    if (lang === 'cn') {
        results = await Promise.all([
            import('CommonMessages/eureka-common-errorcode/cn.json'),
            import('CommonMessages/eureka-company/cn.json')
        ])
    }
    if (lang === 'en') {
        results = await Promise.all([
            import('CommonMessages/eureka-common-errorcode/en.json'),
            import('CommonMessages/eureka-company/en.json')
        ])
    }
    if (lang === 'jp') {
        results = await Promise.all([
            import('CommonMessages/eureka-common-errorcode/jp.json'),
            import('CommonMessages/eureka-company/jp.json')
        ])
    }
    if (lang === 'tw') {
        results = await Promise.all([
            import('CommonMessages/eureka-common-errorcode/tw.json'),
            import('CommonMessages/eureka-company/tw.json')
        ])
    }

    const data = results?.reduce((obj, { default: data }) => {
        return _.merge(obj, data);
    }, {});

    if (data) {
        i18n.global.setLocaleMessage(lang, data);
    }
    return i18n;
}
